import React, { useRef, useEffect } from 'react';
import { useOven } from '../../contexts/OvenContext';

const Hero = () => {
  const { PRODUCTS, currentProduct, isBaking, productReady, showGif, getProduct, startBaking, resetOven } = useOven();
  const videoRef = useRef(null);
  const gifRef = useRef(null);
  const product = getProduct(currentProduct);

  useEffect(() => {
    if (videoRef.current && product && !showGif) {
      videoRef.current.src = product.video || '';
      videoRef.current.load();
      videoRef.current.play().catch(() => {});
    }
  }, [product, showGif]);

  useEffect(() => {
    if (gifRef.current && showGif && product) {
      gifRef.current.src = product.gif || '';
    }
  }, [showGif, product]);

  const handleSelect = (category) => {
    if (productReady) { resetOven(); setTimeout(() => startBaking(category), 300); }
    else { startBaking(category); }
  };

  const handleBakeAgain = () => {
    resetOven();
    setTimeout(() => startBaking(currentProduct), 300);
  };

  return (
    <section className="min-h-screen flex flex-col lg:flex-row items-center px-4 md:px-8 lg:px-16 py-20 lg:py-28 relative overflow-hidden bg-gradient-to-br from-background to-background-alt">
      <div className="absolute top-[-30%] right-[-10%] w-[600px] h-[600px] bg-gold/5 rounded-full pointer-events-none" />
      
      <div className="flex-1 max-w-[540px] relative z-10 text-center lg:text-left">
        <div className="inline-flex items-center gap-2 bg-gold/10 text-gold px-4 py-1.5 rounded-full text-xs font-semibold uppercase border border-gold/10 mb-6">
          <span className="w-2 h-2 bg-gold rounded-full animate-pulse-dot" />
          🎬 Horneado en Vivo
        </div>
        
        <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-primary leading-[1.05] mb-4">
          El <span className="text-gold italic relative">horno</span> mágico<br />de la panadería
        </h1>
        
        <p className="text-base text-text-secondary leading-relaxed mb-6 max-w-[440px] mx-auto lg:mx-0">
          Selecciona un producto y mira el proceso de horneado en tiempo real.
        </p>

        <div className="flex flex-wrap justify-center lg:justify-start gap-2 mb-6">
          {PRODUCTS.map(p => (
            <button
              key={p.id}
              onClick={() => handleSelect(p.category)}
              className={`px-4 py-2 border rounded-full font-medium text-sm transition min-h-[44px] flex items-center gap-1 shadow-sm ${
                currentProduct === p.category
                  ? 'bg-primary text-white border-primary shadow-md'
                  : 'bg-white text-text-secondary border-primary/10 hover:border-gold hover:text-primary'
              }`}
            >
              {p.icon} {p.name.split(' ')[0]}
            </button>
          ))}
        </div>

        <div className="flex flex-wrap justify-center lg:justify-start gap-2">
          <button 
            onClick={() => {
              if (productReady) { resetOven(); setTimeout(() => startBaking(currentProduct), 300); }
              else if (!isBaking) startBaking(currentProduct);
            }}
            className="btn-primary"
          >
            ▶ Ver Horneado
          </button>
          <button 
            onClick={() => document.getElementById('productos')?.scrollIntoView({ behavior: 'smooth' })}
            className="btn-secondary"
          >
            Ver productos →
          </button>
        </div>
      </div>

      {/* Horno */}
      <div className="flex-1 w-full h-[350px] md:h-[450px] lg:h-[580px] relative rounded-xl lg:rounded-2xl overflow-hidden shadow-lg bg-primary mt-6 lg:mt-0 lg:ml-6">
        <video ref={videoRef} muted playsInline className={`w-full h-full object-cover bg-primary ${showGif ? 'hidden' : 'block'}`} />
        <img ref={gifRef} alt="Producto horneado" className={`w-full h-full object-cover bg-primary ${showGif ? 'block' : 'hidden'}`} />

        <div className={`absolute bottom-4 left-1/2 -translate-x-1/2 bg-primary/80 backdrop-blur-md px-4 py-2 rounded-full text-white text-sm flex items-center gap-2 z-10 border border-white/10 min-h-[36px] transition ${productReady ? 'bg-green-600/90 border-green-600/30' : ''}`}>
          <span className={`w-2 h-2 rounded-full ${productReady ? 'bg-white' : 'bg-gold animate-pulse-dot'}`} />
          <span>
            {isBaking ? `🔥 ${product?.name || 'Producto'} horneándose...` :
             productReady ? `✅ ¡${product?.name || 'Producto'} horneado!` :
             '🎬 Selecciona un producto'}
          </span>
        </div>

        {productReady && (
          <button onClick={handleBakeAgain} className="absolute bottom-20 left-1/2 -translate-x-1/2 z-10 px-4 py-2 md:px-6 md:py-3 rounded-full bg-white/15 text-white backdrop-blur-sm border border-white/10 font-semibold text-sm hover:bg-white/25 transition min-h-[40px] flex items-center gap-2 shadow-lg animate-fade-up">
            🔄 Hornear otro
          </button>
        )}
      </div>
    </section>
  );
};

export default Hero;